import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function CopyOfCustomerNotifications__loadingSkeleton() {
    return (
        <React.Fragment>
            <div className="overflow-hidden">
                <div className="d-flex">
                    <div>
                        <Skeleton count={1} height={20} width={250} />
                    </div>
                    <div className="ms-auto">
                        <Skeleton count={1} height={35} width={100} className="ms-3" />
                    </div>
                </div>
                <div className="ms-auto">
                    <div className="">
                        <Skeleton count={1} height={20} width={150} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(CopyOfCustomerNotifications__loadingSkeleton)